<template>
    <div>
    <Header></Header>
    <Login></Login>
    <!-- <div class="banner"></div> -->
    <img class="banner" src="../assets/images/businessCooperation/商务合作banner@2x.png" alt="">
    <div class="business-cooperation">
        <div class="business-cooperation-wrapper">
            <div class="business-cooperation-wrapper-left">
                <div class="business-title">商务合作</div>
                <div class="business-enTitle">Business Cooperation</div>
                <div class="business-info">感谢您对澜城数据楼盘库开放平台的关注，目前我们有以下几种商务合作方式，请选择您期望的合作方式与我们联系。</div>
                <img src="../assets/images/businessCooperation/装饰元素1@2x.png" alt="">
            </div>
            <div class="business-cooperation-wrapper-right">
                <div class="qrcode-part">
                    <div class="qrcode-part-wrapper">
                        <div class="qrcode-title">商务合作</div>
                        <div class="qrcode-img">
                            <div class="business-img">
                                <img src="../assets/images/businessCooperation/商务微信@2x.png" alt="">
                                <span>商务微信</span>
                            </div>
                            <div class="wechat-img">
                                <img src="../assets/images/businessCooperation/微信公众号3@2x.png" alt="">
                                <span>微信公众号</span>
                            </div>
                        </div>
                        <div class="scan">微信扫一扫关注</div>
                        <div class="search">搜索关注：<span>澜城数据City Wave Data</span></div>
                    </div>
                </div>
                <div class="newContent-address">
                    <div class="new-content">
                        <div class="title">获取最新分享内容</div>
                        <div class="contact">商务联系人  金老师</div>
                        <div class="phone"><img src="../assets/images/businessCooperation/phone.png" alt=""><span>189-1782-5312</span></div>
                    </div>
                    <div class="address-postcode-email">
                        <div class="address">地址:上海市江场三路128号9楼澜思科技</div>
                        <div class="postcode">邮编：200436</div>
                        <div class="email">邮箱：BD1@realtynavi.com</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Footer class="foot"></Footer>
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Login from "@/components/Login.vue";
export default {
  components: {
    Header,
    Footer,
    Login
  },
  data() {
    return {};
  },
  methods: {},
  created() {}
};
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: auto;
  display: block;
  // height: 240px;
  // background: url("../assets/images/businessCooperation/商务合作banner@2x.png")
  //   no-repeat;
  // background-size: 100% 100%;
}

.business-cooperation {
  background: #fff;
  padding-bottom: 100px;
  overflow: hidden;

  .business-cooperation-wrapper {
    width: 1140px;
    height: 370px;
    margin: 0 auto;
    margin-top: 56px;
    overflow: hidden;

    .business-cooperation-wrapper-left {
      width: 35%;
      float: left;

      .business-title {
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #272727;
        line-height: 40px;
      }

      .business-enTitle {
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #999999;
        line-height: 22px;
        letter-spacing: 2px;
      }

      .business-info {
        margin-top: 56px;
        width: 280px;
        height: 51px;
        font-size: 12px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #666666;
        line-height: 17px;
      }

      img {
        width: 139px;
        height: 66px;
        display: block;
        margin-top: 103px;
      }
    }

    .business-cooperation-wrapper-right {
      width: 65%;
      float: left;

      .qrcode-part {
        width: 360px;
        height: 370px;
        background: rgba(56, 128, 244, 0.06);
        border-radius: 2px;
        overflow: hidden;
        float: left;

        .qrcode-part-wrapper {
          margin: 32px;

          .qrcode-title {
            height: 30px;
            font-size: 22px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #272727;
            line-height: 30px;
          }

          .qrcode-img {
            width: 100%;
            height: 154px;
            margin-top: 32px;
            display: flex;
            justify-content: space-between;

            .business-img,
            .wechat-img {
              width: 124px;
              height: 154px;
              text-align: center;

              img {
                width: 124px;
                height: 124px;
                display: block;
              }
              span {
                margin-top: 10px;
                height: 20px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #272727;
                line-height: 20px;
              }
            }
          }

          .scan {
            margin-top: 56px;
            font-size: 12px;
            color: #666;
          }

          .search {
            font-size: 12px;
            color: #666;

            span {
              color: #3880f4;
            }
          }
        }
      }

      .newContent-address {
        width: 320px;
        height: 370px;
        float: left;
        margin-left: 32px;

        .new-content {
          width: 256px;
          height: 110px;
          padding: 32px;
          background: rgba(56, 128, 244, 0.06);

          .title {
            height: 30px;
            font-size: 22px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #272727;
            line-height: 30px;
          }

          .contact {
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #272727;
            line-height: 20px;
            margin-top: 16px;
          }

          .phone {
            height: 20px;
            overflow: hidden;
            margin-top: 24px;

            img {
              width: 14px;
              height: 14px;
              float: left;
              margin-top: 3px;
            }

            span {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #272727;
              line-height: 20px;
              float: left;
              margin-left: 3px;
            }
          }
        }

        .address-postcode-email {
          width: 256px;
          height: 100px;
          padding: 32px;
          background: rgba(56, 128, 244, 0.06);
          margin-top: 32px;

          .address,
          .postcode,
          .email {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #272727;
            line-height: 20px;
          }

          .postcode {
            margin: 22px 0;
          }
        }
      }
    }
  }
}

.foot {
  width: 100%;
  height: 330px;
  position: absolute;
  bottom: 0;
}
</style>


